import { useState, useEffect } from 'react'
import { getPermissionUsers, type PermissionUser } from '../services/tenant-permission-api'

interface UseTenantPermissionUsersResult {
  users: PermissionUser[]
  loading: boolean
  error: Error | null
  refresh: () => void
}

export function useTenantPermissionUsers(
  tenantCode: string | null,
  sysPermissionId: string
): UseTenantPermissionUsersResult {
  const [users, setUsers] = useState<PermissionUser[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    if (!tenantCode) return

    let cancelled = false

    const fetchUsers = async () => {
      try {
        setLoading(true)
        setError(null)
        const data = await getPermissionUsers(tenantCode, sysPermissionId)
        if (!cancelled) {
          setUsers(data)
          setLoading(false)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error('Failed to fetch permission users'))
          setLoading(false)
        }
      }
    }

    fetchUsers()

    return () => {
      cancelled = true
    }
  }, [tenantCode, sysPermissionId, refreshKey])

  const refresh = () => {
    setRefreshKey(prev => prev + 1)
  }

  return { users, loading, error, refresh }
}
